import { StoryblokImage } from '@cinch-nx/data-storyblok'
import styles from './why-cinch.module.css'
import { StoryBlockTitleAndText } from '../../types/store-page'
import { Heading } from '@cinch-labs/design-system'
import { useViewport } from '@cinch-labs/shared-util'
import { WhyCinchCarousel } from './why-cinch-carousel'

export interface WhyBuyProps {
  whyBuyContent: StoryBlockTitleAndText[]
  whyBuyImage?: StoryblokImage
}

export const WhyBuyContentCard = ({
  content,
}: {
  content: StoryBlockTitleAndText
}) => {
  const { title, text } = content
  return (
    <div className={styles.contentCard}>
      <Heading className={styles.heading}>{title}</Heading>
      <p className={styles.paragraph}>{text}</p>
    </div>
  )
}

export const WhyCinch = ({ whyBuyContent }: WhyBuyProps) => {
  const { vw } = useViewport({
    updateOnResize: true,
    updateOnOrientationChange: true,
  })

  const isMobile = vw < 768

  return isMobile ? (
    <section className={styles.carouselWrapper}>
      <WhyCinchCarousel
        content={whyBuyContent}
        carouselName={'why-buy-carousel'}
      />
    </section>
  ) : (
    <section className={styles.root}>
      <div className={styles.contentContainer}>
        {whyBuyContent.map((content) => (
          <WhyBuyContentCard
            key={`content-${content.title}`}
            content={content}
          />
        ))}
      </div>
      {/* <div className={styles.imageContainer}>
        <img
          style={{ height: '100%', width: 'auto' }}
          src={whyBuyImage.filename}
          alt={whyBuyImage.filename || ''}
        />
      </div> */}
    </section>
  )
}
